<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-button
        type="primary"
        v-if="isAdmin()"
        class="add"
        size="small"
        @click="addRule"
      >
        <i class="el-icon-plus"></i>
        新增规则
      </el-button>
      <el-button
        type="danger"
        v-if="isAdmin()"
        size="small"
        class="delete"
        @click="delMulData"
      >
        <i class="el-icon-delete"></i>删除
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入规则名称"
              clearable
              v-model="searchForm.name"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="名称"
      ></el-table-column>
      <el-table-column
        prop="ruleType"
        align="center"
        label="规则类型"
        :formatter="ruleTypeFormatter"
      ></el-table-column>
      <el-table-column prop="ruleType" align="center" label="规则内容"
        ><template slot-scope="scope">
          <div class="cell">
            <span>{{
              scope.row.recognizeMode == 1 ? "模糊匹配" : "精确匹配"
            }}</span>
            <span>{{ showcontent(scope.row) }} </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="100"
        v-if="isAdmin()"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="isAdmin()"
            @click="deleteRule(scope.row)"
            class="btnopt"
            size="small"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="isAdmin()"
            @click="editRule(scope.row)"
            class="btnopt"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增弹框-->
    <el-dialog
      :title="'新增规则'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="规则名称" prop="name">
          <el-input v-model="form.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="规则类型" prop="ruleType">
          <el-select
            v-model="form.ruleType"
            filterable
            clearable
            @change="changeRuleType"
            style="width: 100%"
          >
            <el-option
              v-for="item in ruleTypeOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="匹配模式"
          v-if="form.ruleType != null && form.ruleType != 7 && form.ruleType != 8 "
          prop="recognizeMode"
        >
          <el-select v-model="form.recognizeMode" clearable style="width: 100%">
            <el-option
              v-for="item in recognizeModeOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="适用组别"
          v-if="
            (form.recognizeMode == 2 || form.ruleType == 7) &&
            form.ruleType != 8
          "
          prop="competitionGroupId"
        >
          <el-select
            multiple
            filterable
            clearable
            :reserve-keyword="true"
            v-model="form.competitionGroupId"
            style="width: 100%"
          >
            <el-option
              v-for="item in groupOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
          <div v-if="form.ruleType == 7" style="color: red">
            组别强制兼报报名时须同时上报一组
          </div>
        </el-form-item>
        <el-form-item
          label="关键字匹配"
          v-if="form.recognizeMode == 1 && form.ruleType != 7"
          prop="competitionGroupId"
        >
          <el-input
            v-model="form.competitionGroupId"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="form.ruleType == 3"
          label="排除分组"
          prop="exceptGroup"
        >
          <el-select
            multiple
            filterable
            clearable
            :reserve-keyword="true"
            v-model="form.exceptGroup"
            style="width: 100%"
          >
            <el-option
              v-for="item in groupOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.ruleType == 2" label="最小年龄" prop="minAge">
          <el-date-picker v-model="form.minAge" type="date"> </el-date-picker>
        </el-form-item>
        <el-form-item v-if="form.ruleType == 2" label="最大年龄" prop="maxAge">
          <el-date-picker v-model="form.maxAge" type="date"> </el-date-picker>
        </el-form-item>
        <div v-if="form.ruleType == 4">
          <el-form-item label="组别限制">
            <div
              v-for="(item, index) in form.groupTypeRules"
              :key="item.groupTypeRules"
            >
              <el-row style="margin-bottom: 10px" :gutter="10">
                <el-col :span="6">
                  <el-select v-model="item.groupTypeName">
                    <el-option
                      v-for="item in groupTypeOptions"
                      :key="item"
                      :value="item"
                      :label="item"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="6"
                  ><el-input-number
                    style="width: 100px"
                    :controls="false"
                    v-model="item.number"
                  ></el-input-number>
                </el-col>
                <el-col :span="2">
                  <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    circle
                    @click="deleteGroupTypeRule(index)"
                  ></el-button>
                </el-col>
              </el-row></div
          ></el-form-item>
        </div>
        <div style="text-align: center" v-if="form.ruleType == 4">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addGroupTypeRule"
            circle
          ></el-button>
        </div>
        <div v-if="form.ruleType == 6||form.ruleType == 10">
          <el-form-item label="最大允许报名数">
            <el-input-number
              v-model="form.maxJoinNumber"
              :controls="false"
              :precision="0"
              maxlength="255"
            ></el-input-number>
          </el-form-item>
        </div>
        <div v-if="form.ruleType == 8">
          <el-form-item label="限制规则">
            <div
              v-for="(item, index) in form.groupLimits"
              :key="item.groupLimits">
              <el-row style="margin-bottom: 10px" :gutter="10">
                <el-col :span="15">
                  <el-select
                    multiple
                    filterable
                    clearable
                    :reserve-keyword="true"
                    v-model="item.groupCodes"
                    style="width: 100%">
                    <el-option
                      v-for="item in groupOptions"
                      :value="item.value"
                      :label="item.name"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="2"
                  ><el-input-number
                    style="width: 100%"
                    :controls="false"
                    v-model="item.number"
                  ></el-input-number> 
                  </el-col>
                  <el-col :span="3"
                  >
                  <el-checkbox v-model="item.isRestricted">强制兼报</el-checkbox>                 
                  </el-col>
                <el-col :span="2"
                  >
                   <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    circle
                    @click="deleteGroupRule(index)"
                  ></el-button>
                </el-col>
              </el-row></div
          ></el-form-item>
          <div style="text-align: center">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="addGroupRule"
              circle
            ></el-button>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "../apis/matchrule";
import GroupApi from "../apis/group";
import moment from "moment";
export default {
  props: ["matchId"],
  data() {
    var validateformGroups = (rule, value, callback) => {
      if (value === "" && this.form.ruleType != 6) {
        callback(new Error("请选择组别或输入关键字"));
      } else {
        callback();
      }
    };
    return {
      formTitle: "新增规则",
      isLoading: false,
      dialogFormVisible: false,
      multipleSelection: [],
      total: 0,
      tableListData: [],
      searchForm: {
        name: "",
        matchId: this.matchId,
        page: 1,
        pageSize: 15,
      },
      ruleTypeOptions: [
        { name: "身份证验证", value: 1 },
        { name: "年龄限制", value: 2 },
        { name: "组别不可兼报", value: 3 },
        { name: "组别数量限制", value: 4 },
        { name: "按第一次报名年龄限制", value: 5 },
        { name: "最大允许报名数", value: 6 },
        { name: "组别一对一强制兼报", value: 7 },
        { name: "组别组合强制兼报", value: 8 },
        { name: "选手1性别限制", value: 9 },
        {name:"组别报名数量限制", value:10}
      ],
      recognizeModeOptions: [
        { name: "模糊匹配", value: 1 },
        { name: "精确匹配", value: 2 },
      ],
      groupOptions: [],
      groupTypeOptions: [],
      customGroupOption: [],
      form: {
        id: 0,
        name: "",
        ruleType: null,
        competitionGroupId: null,
        exceptGroup: null,
        minAge: null,
        maxAge: null,
        maxJoinNumber: 0,
        recognizeMode: 1,
        matchId: this.matchId,
        groupTypeRules: [
          { groupTypeName: "", number: 1 },
          { groupTypeName: "", number: 1 },
        ],
        groupLimits: [
          { groupCodes: "", number: 1 ,isRestricted:true},
          { groupCodes: "", number: 1 ,isRestricted:true},
        ],
      },
      formRules: {
        name: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        ruleType: [{ required: true, message: "请选择规则", trigger: "blur" }],
        recognizeMode: [
          { required: true, message: "请选择匹配模式", trigger: "blur" },
        ],
        competitionGroupId: [
          {
            validator: validateformGroups,
            message: "请选择组别或输入关键字",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    changeRuleType(val) {
      if (val == 7 || val == 8) {
        this.form.recognizeMode = 2;
      }
    },
    showcontent(row) {
      var ret = "" + row.competitionGroupId;
      if (row.ruleType == 2) {
        if (row.minAge != null) {
          ret += " 最小出生日期：" + moment(row.minAge).format("YYYY-MM-DD");
        }
        if (row.maxAge != null) {
          ret += " 最大出生日期：" + moment(row.maxAge).format("YYYY-MM-DD");
        }
      } else if (row.ruleType == 3) {
        ret += " " + row.exceptGroup;
      } else if (row.ruleType == 4) {
        if (row.content != null) {
          ret += " " + row.content;
        }
      } else if (row.ruleType == 6) {
        ret += "最大报名组别数：" + row.maxJoinNumber;
      }
      else if(row.ruleType==8)
      {
         ret = " " + row.content;
      }
      return ret;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    addGroupRule() {
      if(this.form.groupLimits==null)
      {
        this.form.groupLimits=[];
      }
      this.form.groupLimits.push({ groupCodes: "", number: 1 ,isRestricted:true});
    },
    deleteGroupRule(index) {
      this.form.groupLimits.splice(index, 1);
    },
    addGroupTypeRule() {
      if(this.form.groupTypeRules==null)
      {
        this.form.groupTypeRules=[];
      }
      this.form.groupTypeRules.push({ groupTypeName: "", number: 1 });
    },
    deleteGroupTypeRule(index) {
      this.form.groupTypeRules.splice(index, 1);
    },
    ruleTypeFormatter(row, column) {
      var ruleTypeName = "";
      switch (row.ruleType) {
        case 1:
          ruleTypeName = "身份证验证";
          break;
        case 2:
          ruleTypeName = "年龄限制";
          break;
        case 3:
          ruleTypeName = "组别不可兼报";
          break;
        case 4:
          ruleTypeName = "组别类型数量限制";
          break;
        case 5:
          ruleTypeName = "按第一次报名年龄限制";
          break;
        case 6:
          ruleTypeName = "最大允许报名数";
          break;
        case 7:
          ruleTypeName = "组别一对一强制兼报";
          break;
        case 8:
          ruleTypeName = "组别组合强制兼报";
          break;
        default:
          case 9:
            ruleTypeName="选手1性别限制"
            break;
              case 10:
            ruleTypeName="组别报名数量限制"
            break;
          break;
      }
      return ruleTypeName;
    },
    isAdmin() {
      return sessionStorage.getItem("userType") == "1";
    },
    editRule(row) {
      this.formTitle = "编辑规则";
      API.get({ id: row.id }).then((result) => {
        this.dialogFormVisible = true;
        this.form = Object.assign({}, result.result);
        if (this.form.recognizeMode == 2) {
          if (
            this.form.competitionGroupId != null &&
            this.form.competitionGroupId != ""
          ) {
            this.form.competitionGroupId =
              this.form.competitionGroupId.split(",");
          }
        }
        if (this.form.minAge != null && this.form.minAge.length > 10) {
          this.form.minAge = this.form.minAge.substring(0, 10);
        }
        if (this.form.maxAge != null && this.form.maxAge.length > 10) {
          this.form.maxAge = this.form.maxAge.substring(0, 10);
        }
        if (this.form.exceptGroup != null && this.form.exceptGroup != "") {
          this.form.exceptGroup = this.form.exceptGroup.split(",");
        }
      });
    },
    addRule() {
      this.formTitle = "新增规则";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
        this.form = {
          id: 0,
          name: "",
          ruleType: null,
          competitionGroupId: null,
          exceptGroup: null,
          minAge: null,
          maxAge: null,
          matchId: this.matchId,
          recognizeMode: 1,
          groupTypeRules: [
            { groupTypeName: "", number: 1 },
            { groupTypeName: "", number: 1 },
          ],
          groupLimits: [
            { groupCodes: "", number: 1 ,isRestricted:true},
            { groupCodes: "", number: 1 ,isRestricted:true },
          ],
        };
      });
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search();
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search();
    },
    doSearch() {
      this.searchForm.page = 1;
      this.search();
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params)
        .then((result) => {
          if (result && result.code == 0) {
            this.tableListData = result.result.data;
            this.total = result.result.recordCount;
          } else {
            this.$message.error({
              showClose: true,
              message: result.result.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm() {
      let that = this;
      this.isLoading = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form);
          if (params.competitionGroupId instanceof Array) {
            params.competitionGroupId = params.competitionGroupId.join();
          }
          if (params.exceptGroup instanceof Array) {
            params.exceptGroup = params.exceptGroup.join();
          }
          if(params.ruleType!=8)
          {
            params.groupLimits=null;
          }
          if (params.id > 0) {
            API.edit(params)
              .then(
                (data) => {
                  if (data.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "更改成功",
                      duration: 2000,
                    });
                    that.dialogFormVisible = false;
                    that.$refs["form"].resetFields();
                    that.search();
                  } else {
                    this.$message.error({
                      showClose: true,
                      message: "更新失败",
                      duration: 2000,
                    });
                  }
                  that.isLoading = false;
                },
                function (err) {
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                  that.isLoading = false;
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
                that.isLoading = false;
              });
          } else {
            API.add(params)
              .then((result) => {
                if (result.code == 0) {
                  this.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 2000,
                  });
                  this.$refs["form"].resetFields();
                  this.dialogFormVisible = false;
                  this.search();
                  this.isLoading = false;
                } else {
                  this.$message.error({
                    showClose: true,
                    message: "新增失败",
                    duration: 2000,
                  });
                  this.isLoading = false;
                }
              })
              .catch((error) => {
                this.$message.error({
                  showClose: true,
                  message: "请求异常",
                  duration: 2000,
                });
                this.isLoading = false;
              });
          }
        } else {
          this.isLoading = false;
        }
      });
    },
    deleteRule(row) {
      let params = { id: row.id };
      this.$confirm("确认删除记录吗？", "提示", { type: "warning" })
        .then(() => {
          API.delete(params)
            .then((result) => {
              console.log(result);
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "删除成功",
                  duration: 2000,
                });
                this.search();
              } else {
                this.$message.error({
                  showClose: true,
                  message: "系统错误",
                  duration: 2000,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "123",
                duration: 2000,
              });
            });
        })
        .catch(() => {});
    },
    /*批量删除*/
    delMulData() {
      let that = this;
      let val = that.multipleSelection;
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id);
      }
      this.$confirm("此操作将永久删除该数据，是否继续？", "提示", {
        confimButtonTexe: "确定",
        cancelButtonTexe: "取消",
        type: "warning",
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() })
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 0) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 2000,
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "删除操作异常，请重试",
                    duration: 2000,
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        }
      });
      this.$refs.multipleTable.clearSelection();
    },
  },
  mounted() {
    this.search();
    GroupApi.select({ matchId: this.matchId }).then((res) => {
      this.groupOptions = res.result;
    });
    API.select().then((res) => {
      this.customGroupOption = res.result;
    });
    GroupApi.selectType({ matchId: this.matchId }).then((res) => {
      this.groupTypeOptions = res.result;
    });
  },
};
</script>


// WEBPACK FOOTER //
// src/components/MatchRule.vue